import React, { useState } from "react";
import Dialog from "./Dialog";
import { Action, Field, Note } from "../../pages/MVP/shared";
import { useLanguage } from "../../contexts/LanguageContext";

interface Props {
  title: string;
  description?: React.ReactNode;
  /** Что именно удаляем/меняем: имя, превью, сторона. */
  subject?: React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  error?: string;
  /** Пользователь должен ввести это значение, чтобы подтвердить (роспуск клана). */
  requireText?: string;
  onConfirm: () => void;
  onClose: () => void;
}

/** Брендированное подтверждение вместо window.confirm. Фокус — на «Отмена». */
export default function ConfirmDialog({
  title,
  description,
  subject,
  confirmLabel,
  cancelLabel,
  danger = true,
  busy,
  error,
  requireText,
  onConfirm,
  onClose,
}: Props) {
  const { t } = useLanguage();
  const [typed, setTyped] = useState("");
  const blocked = !!requireText && typed.trim() !== requireText;
  return (
    <Dialog
      size="sm"
      label={title}
      onClose={onClose}
      footer={
        <>
          <Action type="button" autoFocus onClick={onClose} disabled={busy}>
            {cancelLabel || t("common.cancel")}
          </Action>
          <Action
            type="button"
            $variant={danger ? "danger" : "primary"}
            disabled={busy || blocked}
            aria-busy={busy}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Action>
        </>
      }
    >
      <h2>{title}</h2>
      {subject}
      {description && <Note>{description}</Note>}
      {requireText && (
        <label style={{ display: "grid", gap: 8 }}>
          <Note>{t("common.type_to_confirm", { value: requireText })}</Note>
          <Field
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            aria-label={t("common.type_to_confirm", { value: requireText })}
            autoComplete="off"
          />
        </label>
      )}
      {error && <p role="alert">{error}</p>}
    </Dialog>
  );
}
